var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1117_176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.931519,
    width: 24,
    height: 27.1233,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1117_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0486 19.2169H4.03906V17.2668H22.0486V19.2169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1123 2.06177H11.9806V13.9145H9.1123V2.06177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.03552H6.97404V13.8208C6.88299 13.8837 6.82705 13.9542 6.76744 13.9589C4.00041 14.1711 4.00041 14.1702 4.00041 10.9806L4 4.03552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1245 22.7004V24.6646H4.02344V22.7004H17.1245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0268 13.84H14.1777V7.69385H17.0268V13.84Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhTransaction);
export default __webpack_public_path__ + "static/media/wh_transaction.2f6b2515871500a9468af76691508ef6.svg";
export { ForwardRef as ReactComponent };